/* LAB build post: before/after slider and click-to-play YouTube. The photo viewer is PhotoSwipe (MIT), loaded by the section. */

if (!customElements.get('lab-compare')) {
  class LabCompare extends HTMLElement {
    connectedCallback() {
      const range = this.querySelector('input[type="range"]');
      if (!range) return;
      const update = () => this.style.setProperty('--pos', `${range.value}%`);
      range.addEventListener('input', update);
      update();
    }
  }
  customElements.define('lab-compare', LabCompare);
}

if (!customElements.get('lab-video')) {
  class LabVideo extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const id = encodeURIComponent(this.dataset.videoId);
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
        iframe.title = button.textContent.trim() || 'Video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        this.replaceChildren(iframe);
      }, { once: true });
    }
  }
  customElements.define('lab-video', LabVideo);
}
